export const DEFAULT_LOCALE = 'en-GB'
export const LOCALE_COOKIE = 'NEXT_LOCALE'
